import { SETTINGS } from '../constants'
import Wix from 'Wix';
import { defaultSettingsState } from '../../defaulState'
import server from '../api/server'
// import { fullWidthConverter, convertParallaxImage, getHeight } from '../api/utils'

const APP_NAME = 'impressive-text-slider-'.concat(Wix.Utils.getCompId());
const TEMPLATES_NAME = 'impressive-text-slider-templates'.concat(Wix.Utils.getCompId());


const settingsActions = {

    initSettings(settings) {
        return {
            type: SETTINGS.INIT_SETTINGS,
            payload: settings,
        }
    },

    updateSettings(data) {
        const viewMode = Wix.Utils.getViewMode()
        let settings = viewMode === 'site' ? data.publishedSettings : data.settings
        settings.dataIsLoad = true

        if (viewMode === 'editor') {
            // если у слайда нет id для того, чтобы найти слайд при восстановлении настроек
            settings.slides.map(slide => {
                if (slide.id === undefined) {
                    slide.id = `${parseInt(Math.random() * 1000000000000000)}`
                }
            })
        }

        return {
            type: SETTINGS.UPDATE_SETTINGS,
            payload: settings,
        }
    },

    changeWidgetDimansion(newDimension) {
        return {
            type: SETTINGS.CHANGE_WIDGET_DIMENSION,
            payload: newDimension,
        }
    },

    changeDeviceType(newType) {
        return {
            type: SETTINGS.CHANGE_DEVICE_TYPE,
            payload: newType,
        }
    },

    updateSlides(slides) {
        return {
            type: SETTINGS.UPDATE_SLIDES,
            payload: slides,
        }
    },

    previewTemplateSlides(template) {
        return {
            type: SETTINGS.PREVIEW_TEMPLATE_SLIDES,
            payload: template,
        }
    },

    stopShowTemplate() {
        sessionStorage.removeItem('demo-'.concat(Wix.Utils.getCompId()))
        window.location.reload()
        return {
            type: SETTINGS.STOP_SHOW_TEMPLATE,
        }
    },
    addLanguageToCaptions(langs) {
        return {
            type: SETTINGS.ADD_LANGUAGE_TO_CAPTIONS,
            payload: langs
        }
    },


}

export { settingsActions }